import { setSortAndFilter } from 'component/page/search/store/search';
import { SortMatrix } from 'gql/autogen/SortMatrix';
import { FilterMatrix } from 'gql/autogen/FilterMatrix';
import { createSelector } from '@reduxjs/toolkit';
import { selectFilterState, selectMatrixFromSearchState, selectSortState } from 'component/page/search/store/search.selectors';
import { CategoryId } from 'core/type/Category.types';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesQuickCategoryFilterItemClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesQuickCategoryFilterItemClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { FilterCode } from 'gql/autogen/FilterCode';
import { selectTextForTextSearch } from 'store/slice/home';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';
import { FilterState } from 'component/common/Filter/Filter.types';
import { Sort } from 'gql/autogen/Sort';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';
import { isOn } from 'core/window/bootstrapConfig';
import { FeatureName } from 'core/constant/FeatureName';

interface StateProps {
    cityName: string;
    sort: Sort;
    filter: FilterState;
    sortMatrix: SortMatrix;
    filterMatrix: FilterMatrix;
    selectedCategory?: string;
    screenSize: ScreenSize;
    config: BootstrapConfig;
    isPageContainerSpacing: boolean;
}

interface DispatchProps {
    setCategoriesFilter: (sort: Sort, filter: FilterState, index: number, count: number) => void;
}

export type Props = StateProps & DispatchProps;

export const mapStateToProps = createSelector(
    selectTextForTextSearch,
    selectSortState,
    selectFilterState,
    selectMatrixFromSearchState,
    selectScreenSize,
    selectConfigFromBootstrap,
    (cityName, sort, filter, matrix, screenSize, config): StateProps => {
        const sortMatrix = matrix?.sort || {};
        const filterMatrix = matrix?.filter || {};
        const selectedCategory = filter.valueFilterMatrix.find((f) => f.code === FilterCode.Category)?.values[0];
        const isPageContainerSpacing = isOn(FeatureName.PageContainerSpacing, config);

        return { cityName, sort, filter, sortMatrix, filterMatrix, selectedCategory, screenSize, config, isPageContainerSpacing };
    },
);

export const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    setCategoriesFilter: (sort: Sort, filter: FilterState, index: number, count: number) => {
        const categoryValue = filter.valueFilterMatrix.length > 0 ? filter.valueFilterMatrix[0].values[0] : CategoryId.All;
        trackElementEvent<ActivitiesQuickCategoryFilterItemClickEventActivitiesFieldsV1>(
            ActivitiesQuickCategoryFilterItemClickEventActivitiesManifestV1.ids,
            { order_index: index, activities_count: count },
            { action_element_value: categoryValue, action_element_index: index },
        );
        dispatch(setSortAndFilter({ sort, filter }));
    },
});
